import React, { useEffect, useState, useRef, useContext } from 'react'
import ReactModal from 'react-modal'
import YellowFrame from '../../../assets/early/svg/YellowFrame.svg'
import RedFrame from '../../../assets/early/svg/RedFrame.svg'
import { ReactComponent as Spotlight } from '../../../assets/early/svg/Spotlight.svg'
import { ReactComponent as ConfirmationPlant } from '../../../assets/early/svg/ConfirmationPlant.svg'
import { ReactComponent as PurpleCheck } from '../../../assets/early/svg/PurpleCheck.svg'
import { ReactComponent as PurpleCross } from '../../../assets/early/svg/PurpleCross.svg'
import { format } from 'date-fns'
import { BigAnimalImages } from '../../../assets/early/bigAnimals/BigAnimalImages'
import { useTranslation } from 'react-i18next'
import { respondToDailyQuestion } from '../../../server/server'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'
import '../../../styles/early/earlyMotion.css'

function ConfirmEmotionModal({ modalVisible, onCancel = () => {}, onConfirm = () => {}, animal = 'tiger', emotion = 'afraid', student = {} }) {
    //const { theme } = useContext(AppContext);
    const [process, setProcess] = useState(false)
    const { t } = useTranslation()
    useTrackedSurface(ANALYTICS_EVENTS.EARLY_CLASSROOM_EMOTION_CONFIRMATION_VIEWED, {
        active: modalVisible,
        contentId: student?.id,
        content: emotion,
    })

    const submit = async () => {
        setProcess(true)
        const data = {
            emotion: emotion,
            created_date: Date.now(),
            day_code: format(Date.now(), 'yyyy-MM-dd'),
            user_id: student?.id,
            type: 'daily',
        }
        const resp = await respondToDailyQuestion(data)
        if (resp.status == 200) {
            setProcess(false)
            onConfirm()
        }
    }

    useEffect(() => {
        if (modalVisible) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
        return () => {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalVisible])

    return (
        <ReactModal
            transparent
            ariaHideApp={false}
            isOpen={modalVisible}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={onCancel}
            className="noScroll"
            portalClassName="ReactModalPortal em-modal-portal"
            closeTimeoutMS={240}
            style={{
                overlay: {
                    backgroundColor: '#00000065',
                    zIndex: 0,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 600,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                    position: 'relative',
                },
            }}
        >
            <div className="bg-[#5E639B] border-[10px] border-[#FDDF6D] h-[655px] relative rounded-[60px] mt-[5px] px-[30px] py-[20px] flex flex-col items-center overflow-hidden em-modal-card">
                <Spotlight style={{ position: 'absolute', top: -120, left: 50, alignSelf: 'center' }} width={400} />
                <ConfirmationPlant style={{ position: 'absolute', top: 135, left: 0 }} />
                <div className="absolute em-modal-hero" style={{ top: 125 }}>
                    {React.cloneElement(BigAnimalImages[animal][emotion], { width: 200 })}
                </div>
                <p className="text-white text-[36px] leading-[50px] font-bold text-left w-full capitalize em-title-in em-d1">{t(emotion)}</p>
                <div className="flex flex-1"></div>
                <div className="flex flex-col items-center justify-end em-title-in em-d2">
                    <p className="text-center text-white text-[20px]  font-bold max-w-[70%]">{t('Does this best describe how you’re feeling right now,')}</p>
                    <p className="text-center text-[#FDDF6D] text-[30px]  font-bold mt-2">
                        {student?.first_name} {student?.last_name}?
                    </p>
                </div>
                <div className="flex flex-row items-center justify-center gap-[20px] mt-4 em-title-in em-d3">
                    <button
                        className=" bg-no-repeat bg-contain flex flex-row items-center justify-center gap-[5px] pl-[15px] pr-[11px] em-tap em-tap--card"
                        style={{ backgroundImage: `url(${RedFrame})`, width: 150, height: 75 }}
                        onClick={onCancel}
                    >
                        <p className="text-[30px]  font-bold text-[#5E639B]">{t('No')}</p>
                        <PurpleCross />
                    </button>
                    <button
                        className=" bg-no-repeat bg-contain flex flex-row items-center justify-center gap-[5px] pl-[15px] pr-[11px] em-tap em-tap--card"
                        style={{ backgroundImage: `url(${YellowFrame})`, width: 200, height: 75 }}
                        onClick={submit}
                    >
                        <p className="text-[30px] font-bold text-[#5E639B]">{t('Yes')}</p>
                        <PurpleCheck />
                    </button>
                </div>
            </div>
        </ReactModal>
    )
}

export default ConfirmEmotionModal
